<template>
  <v-col
    v-if="showEbay"
    :cols="cols"
    :sm="sm"
    :md="md"
    :lg="lg"
    :xs="xs"
    class="part-export-col"
  >
    <div class="part-export-field">
      <div class="part-export-field__header">
        <img
          src="@/assets/ebay-logo.svg"
          alt="eBay"
          class="part-export-field__logo"
        />
      </div>
      <v-checkbox
        :model-value="ebayValue"
        :label="$t('parts.inventory.form.export')"
        color="red-darken-3"
        hide-details
        density="compact"
        class="part-export-field__checkbox"
        :readonly="readonly"
        @update:model-value="!readonly && $emit('update:exportEbay', $event)"
      />
    </div>
  </v-col>
  <v-col
    v-if="showRr"
    :cols="cols"
    :sm="sm"
    :md="md"
    :lg="lg"
    :xs="xs"
    class="part-export-col"
  >
    <div class="part-export-field">
      <div class="part-export-field__header">
        <img
          src="@/assets/rr-logo.png"
          alt="RR"
          class="part-export-field__logo"
        />
        <span>RR</span>
      </div>
      <v-checkbox
        :model-value="rrValue"
        :label="$t('parts.inventory.form.export')"
        color="red-darken-3"
        hide-details
        density="compact"
        class="part-export-field__checkbox"
        :readonly="readonly"
        @update:model-value="!readonly && $emit('update:rrExport', $event)"
      />
    </div>
  </v-col>
</template>

<script>
export default {
  name: "ExportMarketplaces",
  props: {
    exportEbay: { type: Boolean, default: true },
    rrExport: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false },
    forceEbay: { type: Boolean, default: false },
    forceRr: { type: Boolean, default: false },
    partInstitutionRr: { type: Boolean, default: false },
    cols: { type: [Number, String], default: 6 },
    xs: { type: [Number, String], default: undefined },
    sm: { type: [Number, String], default: undefined },
    md: { type: [Number, String], default: 2 },
    lg: { type: [Number, String], default: 2 },
  },
  emits: ["update:exportEbay", "update:rrExport"],
  computed: {
    showEbay() {
      return this.forceEbay || this.$store.getters.institutionExportEbayLeko;
    },
    showRr() {
      return (
        this.forceRr ||
        this.$store.getters.institutionRr === true ||
        this.partInstitutionRr === true
      );
    },
    ebayValue() {
      return this.exportEbay !== false;
    },
    rrValue() {
      return this.rrExport !== false;
    },
  },
};
</script>

<style>
.part-export-field {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.part-export-field__header {
  height: 24px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  line-height: 24px;
  white-space: nowrap;
}
.part-export-field__logo {
  height: 18px;
  width: auto;
  display: block;
  object-fit: contain;
}
.part-export-field__checkbox {
  margin: 0;
  padding: 0;
}
.part-export-field__checkbox .v-selection-control {
  min-height: 36px;
  height: 36px;
}
.part-export-field__checkbox .v-label {
  line-height: 36px;
}
</style>
